import React from 'react'
import { Paper, Typography, Grid } from '@material-ui/core'
import { browsers } from 'constants/browsers'

import './styles.scss'

export default function OldBrowser() {
  return (
    <Grid xs={12}>
      <Paper variant="outlined" className="ie-paper">
        <Typography variant="h4">
          Sorry, you are using an outdated version, please update your browser.
        </Typography>
        <Typography className="heading" variant="h6">
          Supported browsers:
          {browsers.map(({ name, href }, i, arr) => {
            let newName
            if (arr[i].name !== arr[arr.length - 1].name) {
              newName = ` ${name}, `
            } else {
              newName = name
            }

            return (
              <a
                href={href}
                rel="noopener noreferrer"
                target="_blank"
                className="browser-link"
                key={`${name}-${i}`}>
                {newName}
              </a>
            )
          })}
        </Typography>
      </Paper>
    </Grid>
  )
}
